/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/UserOrganizations/UserOrganizations.Selectors',[
    'jquery',
    'lodash',
    'global/all',
    'plugins/jquery.proxyRequest',
    'plugins/jquery.rocparams'
], function ($, _, Roc) {
    'use strict';

    var UserOrganizationsSelectors = {        
        wrappers: {
            shipToOrganizations: '[data-roc-wrapper="shipToOrganizations"]',
            organizationBudgetForm: '[data-roc-wrapper="organizationBudgetForm"]'
        },
        buttons: {
            editBudget: '[data-roc-action="editBudget"]',
            cancelBudget: '[data-roc-action="cancelBudget"]',
            submitBudget: '[data-roc-action="submitBudget"]'
        },
        fields: {
            renewalDayOfMonth: '[data-roc-field="customerBudgetRenewalDayOfMonth"]',
            customerBudget: '[data-roc-field="customerBudget"]'
        },
        dynamic: {
            quoteDetails: function(quoteId) {
                return '#quote-' + quoteId + '-details';
            }
        }

    };


    Roc.Logger.debug('UserOrganizations.Selectors.js Loaded:', UserOrganizationsSelectors);

    return UserOrganizationsSelectors;
});
